import { Injectable } from "@angular/core";
import {
  BfxBlotterOrdersContextMenuService,
  BfxLadderBlotterOrdersContextMenuEvent,
} from "../bfx-blotter-orders/bfx-blotter-orders-contextmenu.service";
import { BfxLadderBlotterContextMenuEventType } from "../bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBlotterAction, BfxBlotterOrdersContextMenuItem } from "shared/cubiq-services";
import {
  OrderDataPromiseLookupService,
  SystemConfigPromiseService,
  TraderGroupPromiseLookupService,
  BfxBlotterOrdersContextMenuPromiseService,
  ActiveUserProfilePromiseService,
} from "shared/cubiq-services";

const INBOX_ACTION_IDS: BfxBlotterAction[] = [
  BfxBlotterAction.ACTION_ORDER_ACCEPT,
  BfxBlotterAction.ACTION_ORDER_ACCEPT_INTO,
  BfxBlotterAction.ACTION_ORDER_REJECT,
  BfxBlotterAction.ACTION_VIEW_DETAILS,
  BfxBlotterAction.ACTION_VIEW_AUDIT,
  BfxBlotterAction.ACTION_ORDER_RECAP,
  BfxBlotterAction.ACTION_VIEW_RECAP,
  BfxBlotterAction.ACTION_EXPORT,
  BfxBlotterAction.SEPARATOR,
];
import { LoggerService } from "@bfx/logger";
import { BfxBlotterOrdersActionSubject } from "../bfx-blotter-orders/bfx-blotter-orders-action-subject.module";

const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxBlotterInboxContextMenuService extends BfxBlotterOrdersContextMenuService {
  constructor(
    _orderDataService: OrderDataPromiseLookupService,
    _systemConfigService: SystemConfigPromiseService,
    _traderGroupService: TraderGroupPromiseLookupService,
    _activeUserService: ActiveUserProfilePromiseService,
    _contextMenuService: BfxBlotterOrdersContextMenuPromiseService,
    _actionService: BfxBlotterOrdersActionSubject,
  ) {
    super(
      _orderDataService,
      _systemConfigService,
      _traderGroupService,
      _activeUserService,
      _contextMenuService,
      _actionService,
    );
  }

  protected initMenuItems(): void {
    super.initMenuItems();
  }

  public buildMenu(
    blotter: any,
    pageX: number,
    pageY: number,
    selectedIds: Array<string>,
    selectedItems?: Array<object> | null,
  ): void {
    this.contextMenuService.getMenuItems(selectedIds, this.menuState).then((response: any) => {
      let menuItems = response.menuItems;

      this.menuItems = menuItems = menuItems.filter((menuItem: BfxBlotterOrdersContextMenuItem) => {
        return INBOX_ACTION_IDS.indexOf(menuItem.actionId) >= 0;
      });
      menuItems = this.reduceVisibleMenuItems(menuItems, selectedIds, selectedItems);

      let actionDecorators: any = response.actionDecorators;
      this.showMenuSubject.next(
        new BfxLadderBlotterOrdersContextMenuEvent(
          BfxLadderBlotterContextMenuEventType.MENU_SHOW,
          blotter,
          pageX,
          pageY,
          [],
          actionDecorators,
          menuItems,
        ),
      );
    });
  }
}
